import {Model} from "../Model";
import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";
import LatLong from "./LatLong";

@usingJsonToModelConvertor
export class StoreLogos extends Model{

    @fromJsonObject({key: '144'})
    public logo144!:string;

    @fromJsonObject({key: '192'})
    public logo192!:string;

    @fromJsonObject({key: '512'})
    public logo512!:string;
}

@usingJsonToModelConvertor
export default class BranchInfo extends Model{

    @fromJsonObject({key: 'store_name'})
    public storeName!:string;

    @fromJsonObject({key: 'logo_url'})
    public logoUrl!:string;

    @fromJsonObject({key: 'logos', modelClass: StoreLogos, isArray: false})
    public storeLogos!:StoreLogos;

    @fromJsonObject({key: 'branch_name'})
    public branchName!:string;

    @fromJsonObject({key: "branch_location", modelClass: LatLong, isArray: false})
    public branchLocation! :LatLong;

    @fromJsonObject({key: "contact_numbers", modelClass: String, isArray: true})
    public contactNumbers! :String[];

    @fromJsonObject({key: "is_in_active_time"})
    public isInActiveTime! :boolean;

    @fromJsonObject({key: "active_times"})
    public activeTimes! :string;

}